package com.karyadina.ui.navigation

import com.karyadina.model.AppFeature

// 1. Empty interface for Desktop (it doesn't need Android's Parcelable)
actual interface Parcelable

// 2. Actual Parent Class
actual sealed class Screen : Parcelable

// 3. Actual Subclasses
// Note: We DO NOT use @Parcelize here because it's Android-only.

actual object ScreenHome : Screen()

actual class ScreenFeature actual constructor(
    actual val feature: AppFeature
) : Screen()

actual object ScreenPomodoroHistory : Screen()

actual object ScreenAbout : Screen()

actual object ScreenOnboarding : Screen()

actual object ScreenHelp : Screen()

actual object ScreenFreeSource : Screen()